import { defineComponent, PropType, ref, watch } from 'vue'

import VueEasyLightbox from 'vue-easy-lightbox'

interface ILightboxImage {
    src: string,
    title: string
}

export default defineComponent({
    name: 'ImageZoomOverlayComponent',
    components: {
        VueEasyLightbox // eslint-disable-line
    },
    props: {
        images: {
            required: true,
            type: Array as PropType<ILightboxImage[]>
        },
        index: {
            required: false,
            default: 0,
            type: Number
        },
        modelValue: {
            required: true,
            type: Boolean
        }
    },
    setup (props, { emit }) {
        const zooming = ref(props.modelValue)

        watch(() => props.modelValue, newValue => zooming.value = newValue)
        watch(() => zooming.value, newValue => emit('update:modelValue', newValue))

        return {
            zooming
        }
    }
})